export default {
    animation: Boolean | Object, 
    autoBind: Boolean, 
    contentUrls: Array, 
    dataImageUrlField: String, 
    dataSource: Object | Array, 
    dataSpriteCssClassField: String, 
    dataTextField: String | Array, 
    dataUrlField: String, 
    expandMode: String, 
    loadOnDemand: Boolean, 
    messages: Object, 
    template: String | Function, 

    // Events
    activate: Function, 
    collapse: Function, 
    contentLoad: Function, 
    dataBound: Function, 
    error: Function, 
    expand: Function, 
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/PanelBarProps.js